module.exports = __webpack_public_path__ + "34788a81504020c02223c70ae6d6fc99.svg";